import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/import",
  importCSV: "/import/csv",
  importAmazon: "/import/amazon",
  importAliexpress: "/import/aliexpress",
  manage: "/manage",
  widget: "/widget",
};
